/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_TitleInputs */

const en_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help centre`)
};

const pl_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum pomocy`)
};

/**
* | output |
* | --- |
* | "Help centre" |
*
* @param {Help_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_title = /** @type {((inputs?: Help_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_title(inputs)
	return en_help_title(inputs)
});